// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./CourseImages/mainBackground.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./CourseImages/portalBackground.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./CourseImages/MathPortal.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./CourseImages/CodingPortal.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./CourseImages/GraphicDesigningPortal.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./CourseImages/QuranPortal.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./CourseImages/BusinessPortal.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./CourseImages/EnggineeringPortal.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./CourseImages/Architecture.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./CourseImages/spacePortal.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./CourseImages/CommunicationPortal.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./CourseImages/cal.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./CourseImages/teacherTestimonal.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./CourseImages/kidSchool.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./CourseImages/CeoMsgBg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./CourseImages/footer.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navLinks
{
  color: #03b4c6 !important;
  font-size: 16px;
  font-weight: bolder;
  font-family: sans-serif;
  cursor: pointer;
}
.navLinks:hover{
  color: white !important;
  background-color:#03b4c6;
  border-radius: 1vh;
}
.homeBackground
{

  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size:cover ;
}
.portalIntro{
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size:cover ;
  margin: 4% 0 4% 0;
}
.IntroDesc,.IntroImages{
  width: 50%;
  height: auto;
  float: left;
}
.IntroImage1{
  width: 50%;
  height: 50%;
  
}
.IntroImage2{
  width: 30%;
  height: 30%;
}
.IntroImages{
float: right;
display: flex;
align-items: center;
justify-content: flex-end;

}
.portal_heading
{
  width: 100%;
  padding: 0 3vh 0 3vh;
}
.portal_heading p
{
    font-family: 'VanillaMilk';
    font-size: 40px;
    color: #8b0194;
    font-weight: bold;
    text-align: center;
    padding: 20px;
}
.card {
    /* Add shadows to create the "card" effect */
    max-width: 340px;
    height: 30vh;
    margin: auto;
    transition: 0.3s;
    border-radius: 0px 0px 13px 13px;
  }

.card-color1{
    background-color: #096fdb;
    
}
.card-color2{
    background-color: rgb(245, 69, 56);
    
}.card-color3{
    background-color: rgb(157,65,148);
    height: 35vh;
    
}
.card-color5{    background-color: rgb(255,167,34);  }
.card-color4{    background-color: rgb(50,176,214);}
.card-color6{    background-color: #83a6c6;}
.card-color7{    background-color: #ff5e00;}
.card-color8{    background-color: #224c8d;}
.card-color9{    background-color: #a68969;}
.card-color10 { background-color: #179B9F;}

  .img{
    width: 340px;
    height: 320px; 
    margin: auto;
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
  }
.img1 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); 
}.img2 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); 
}.img3 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); 
}.img4 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); 
}.img5 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); 
}.img6 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___}); 
}
.img7 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___}); 
}
.img8 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___}); 
}
.img9 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___}); 
}
.img10 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.portalsTickIcons{
  display: flex;
    align-items: center;
    justify-content: center;
}
.tickIcon{
  width: 45%;
}
  /* On mouse-over, add a deeper shadow
   */
  .card:hover {
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
  }
  
  /* Add some padding inside the card container */
  .container {
    padding: 0px 16px;
  }
  .break {
    flex-basis: 100%;
    height: 0;
  }
  .H4_Heading{
    font-family: 'Barlow', sans-serif;
    font-size: 32px;
     font-weight: 400; 
      color: rgb(255, 255, 255);
      margin: 10px 0px 20px 0px;
  }
  .fa-check{
    color: white;
  }
  .course-details{
    font-family: sans-serif;
    margin-left: 5px;
    font-weight: lighter;
    font-size: 12px;
  }
.portalHighlights{
    font-family: 'VanillaMilk';
    font-size: 60px;
    color: #8b0194;
    text-align: center;
    z-index: 1;
    padding: 20px;
    /* width: fit-content; */
}

.portalMainPara,.portalBullets,.portalPara{
    width: 100%;
    font-family:sans-serif;
    font-size:115%;
    color: #8b0194;
    /* text-align:center;  */
    padding: 2vh;
    margin-left: 10%;
}
.CEOMsg p{
    width: 80%;
    font-family:sans-serif;
    font-size:120%;
    /* text-align:center;  */
    padding: 2vh;
    margin-left: 10%;
}
.portalPara{
  width: 80%; 
}

.portalBullets{
  width: 80%;
  /* text-align:left;  */
  margin-left: 15%;
}
.portalBtn
{
 width:auto;
 padding:1%;
 background-color: #03b4c6;
 color: white;
 border: 0;
 border-radius: 1vh;
 font-weight: bold;
 margin: 1vh;
}
.teacherTestimonal{
    width: 100%;
    height: 80vh;
    background:  url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    background-size: cover;
    background-position: center;
    display: flex;
  align-items: center;
  justify-content: space-evenly;
  float: left;
  margin-top: 2%;

}
.testimonalBox1,.testimonalBox2{
  width: 60vh;
  height: 60vh;
  background-color: white;
  border: 0;
  border-radius: 5vh;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.teacherName{
  color: #ffb52f;
  text-align: center;
  margin: 10%;
}
.kidSchool{
  background:  url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  float: left;
  margin-top: 2%; 
}
.CEOMsg
{
  background:  url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-size: cover;
  background-position: center;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5%;
}

.footer{
  width: 100%;
  height:auto;
  min-height: 550px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-color: rgb(237, 255, 255);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  /* background-color: #04b2ad; */
  display: flex;
  align-items: center; 
  padding: 0 0 6% 0;
}
.footerImg{
  float: left;
}
.footerContent{
  margin-left: 5%;
  width: 90%;
  margin-top: 0%;
}
.footerText{
  margin-top: 45%;
  width: 30%; 
  float: left;
  font-size: 15px;
  font-family: sans-serif;
  color:#ffffff
}
.footerLinksSection
{
  display: flex;
  align-items: start;
  justify-content: center;
}
.footerLinks,.footerLinks1,.footerLinks2
{
  margin-top: 46vh;
margin-left: 20%;
width: 25%;
  float: left;
  font-size: smaller;
  color: white;
  font-family: sans-serif;
}
.footerLinks2
{
width: 30%;
}
.footerLinks1{
  margin-left: 5%;
  
  }
.footerLinks2{
    margin-left: 5%;
    
}

.avatar-image {
  border-radius: 50%; /* Makes the image circular */
  width: 40px; /* Set the width */
  height: 40px; /* Set the height */
  margin: 0;
  padding: 0;
}

.navLinksArrowHide::after{
  display: none !important; /* Hide the dropdown arrow icon */
} `, "",{"version":3,"sources":["webpack://./src/MyComponents/Home.css"],"names":[],"mappings":"AAAA;;EAEE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;;;EAGE,mDAAoD;EACpD,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,mDAAsD;EACtD,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;EACV,WAAW;;AAEb;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;AACA,YAAY;AACZ,aAAa;AACb,mBAAmB;AACnB,yBAAyB;;AAEzB;AACA;;EAEE,WAAW;EACX,oBAAoB;AACtB;AACA;;IAEI,0BAA0B;IAC1B,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,4CAA4C;IAC5C,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;EAClC;;AAEF;IACI,yBAAyB;;AAE7B;AACA;IACI,kCAAkC;;AAEtC,CAAC;IACG,iCAAiC;IACjC,YAAY;;AAEhB;AACA,iBAAiB,iCAAiC,GAAG;AACrD,iBAAiB,iCAAiC,CAAC;AACnD,iBAAiB,yBAAyB,CAAC;AAC3C,iBAAiB,yBAAyB,CAAC;AAC3C,iBAAiB,yBAAyB,CAAC;AAC3C,iBAAiB,yBAAyB,CAAC;AAC3C,gBAAgB,yBAAyB,CAAC;;EAExC;IACE,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;EAC9B;AACF;IACI,yDAAsD;AAC1D,CAAC;IACG,yDAAwD;AAC5D,CAAC;IACG,yDAAkE;AACtE,CAAC;IACG,yDAAuD;AAC3D,CAAC;IACG,yDAA0D;AAC9D,CAAC;EACC,yDAA8D;AAChE;AACA;EACE,yDAAwD;AAC1D;AACA;EACE,yDAAuD;AACzD;AACA;EACE,0DAA+D;AACjE;AACA;EACE,0DAA8C;AAChD;AACA;EACE,aAAa;IACX,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;EACE,UAAU;AACZ;EACE;IACE;EACF;IACE,wCAAwC;EAC1C;;EAEA,+CAA+C;EAC/C;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,iCAAiC;IACjC,eAAe;KACd,gBAAgB;MACf,yBAAyB;MACzB,yBAAyB;EAC7B;EACA;IACE,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;EACjB;AACF;IACI,0BAA0B;IAC1B,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,cAAc;IACd,cAAc;IACd,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,sBAAsB;IACtB,cAAc;IACd,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;AACpB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;CAEC,UAAU;CACV,UAAU;CACV,yBAAyB;CACzB,YAAY;CACZ,SAAS;CACT,kBAAkB;CAClB,iBAAiB;CACjB,WAAW;AACZ;AACA;IACI,WAAW;IACX,YAAY;IACZ,qDAAwD;IACxD,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,cAAc;;AAEhB;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,qDAAgD;EAChD,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,cAAc;AAChB;AACA;;EAEE,qDAA+C;EAC/C,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,oDAA4C;EAC5C,oCAAoC;EACpC,4BAA4B;EAC5B,kCAAkC;EAClC,sBAAsB;EACtB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,UAAU;EACV,cAAc;AAChB;AACA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB;AACF;AACA;;EAEE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;AACzB;AACA;;EAEE,gBAAgB;AAClB,gBAAgB;AAChB,UAAU;EACR,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;AACzB;AACA;;AAEA,UAAU;AACV;AACA;EACE,eAAe;;EAEf;AACF;IACI,eAAe;;AAEnB;;AAEA;EACE,kBAAkB,EAAE,6BAA6B;EACjD,WAAW,EAAE,kBAAkB;EAC/B,YAAY,EAAE,mBAAmB;EACjC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB,EAAE,iCAAiC;AAC7D","sourcesContent":[".navLinks\n{\n  color: #03b4c6 !important;\n  font-size: 16px;\n  font-weight: bolder;\n  font-family: sans-serif;\n  cursor: pointer;\n}\n.navLinks:hover{\n  color: white !important;\n  background-color:#03b4c6;\n  border-radius: 1vh;\n}\n.homeBackground\n{\n\n  background: url('./CourseImages/mainBackground.png');\n  background-size:cover ;\n}\n.portalIntro{\n  width: 100%;\n  background: url('./CourseImages/portalBackground.png');\n  background-size:cover ;\n  margin: 4% 0 4% 0;\n}\n.IntroDesc,.IntroImages{\n  width: 50%;\n  height: auto;\n  float: left;\n}\n.IntroImage1{\n  width: 50%;\n  height: 50%;\n  \n}\n.IntroImage2{\n  width: 30%;\n  height: 30%;\n}\n.IntroImages{\nfloat: right;\ndisplay: flex;\nalign-items: center;\njustify-content: flex-end;\n\n}\n.portal_heading\n{\n  width: 100%;\n  padding: 0 3vh 0 3vh;\n}\n.portal_heading p\n{\n    font-family: 'VanillaMilk';\n    font-size: 40px;\n    color: #8b0194;\n    font-weight: bold;\n    text-align: center;\n    padding: 20px;\n}\n.card {\n    /* Add shadows to create the \"card\" effect */\n    max-width: 340px;\n    height: 30vh;\n    margin: auto;\n    transition: 0.3s;\n    border-radius: 0px 0px 13px 13px;\n  }\n\n.card-color1{\n    background-color: #096fdb;\n    \n}\n.card-color2{\n    background-color: rgb(245, 69, 56);\n    \n}.card-color3{\n    background-color: rgb(157,65,148);\n    height: 35vh;\n    \n}\n.card-color5{    background-color: rgb(255,167,34);  }\n.card-color4{    background-color: rgb(50,176,214);}\n.card-color6{    background-color: #83a6c6;}\n.card-color7{    background-color: #ff5e00;}\n.card-color8{    background-color: #224c8d;}\n.card-color9{    background-color: #a68969;}\n.card-color10 { background-color: #179B9F;}\n\n  .img{\n    width: 340px;\n    height: 320px; \n    margin: auto;\n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n  }\n.img1 {\n    background-image: url('./CourseImages/MathPortal.png'); \n}.img2 {\n    background-image: url('./CourseImages/CodingPortal.png'); \n}.img3 {\n    background-image: url('./CourseImages/GraphicDesigningPortal.png'); \n}.img4 {\n    background-image: url('./CourseImages/QuranPortal.png'); \n}.img5 {\n    background-image: url('./CourseImages/BusinessPortal.png'); \n}.img6 {\n  background-image: url('./CourseImages/EnggineeringPortal.png'); \n}\n.img7 {\n  background-image: url('./CourseImages/Architecture.png'); \n}\n.img8 {\n  background-image: url('./CourseImages/spacePortal.png'); \n}\n.img9 {\n  background-image: url('./CourseImages/CommunicationPortal.png'); \n}\n.img10 {\n  background-image: url(./CourseImages/cal.jpeg);\n}\n.portalsTickIcons{\n  display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.tickIcon{\n  width: 45%;\n}\n  /* On mouse-over, add a deeper shadow\n   */\n  .card:hover {\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n  }\n  \n  /* Add some padding inside the card container */\n  .container {\n    padding: 0px 16px;\n  }\n  .break {\n    flex-basis: 100%;\n    height: 0;\n  }\n  .H4_Heading{\n    font-family: 'Barlow', sans-serif;\n    font-size: 32px;\n     font-weight: 400; \n      color: rgb(255, 255, 255);\n      margin: 10px 0px 20px 0px;\n  }\n  .fa-check{\n    color: white;\n  }\n  .course-details{\n    font-family: sans-serif;\n    margin-left: 5px;\n    font-weight: lighter;\n    font-size: 12px;\n  }\n.portalHighlights{\n    font-family: 'VanillaMilk';\n    font-size: 60px;\n    color: #8b0194;\n    text-align: center;\n    z-index: 1;\n    padding: 20px;\n    /* width: fit-content; */\n}\n\n.portalMainPara,.portalBullets,.portalPara{\n    width: 100%;\n    font-family:sans-serif;\n    font-size:115%;\n    color: #8b0194;\n    /* text-align:center;  */\n    padding: 2vh;\n    margin-left: 10%;\n}\n.CEOMsg p{\n    width: 80%;\n    font-family:sans-serif;\n    font-size:120%;\n    /* text-align:center;  */\n    padding: 2vh;\n    margin-left: 10%;\n}\n.portalPara{\n  width: 80%; \n}\n\n.portalBullets{\n  width: 80%;\n  /* text-align:left;  */\n  margin-left: 15%;\n}\n.portalBtn\n{\n width:auto;\n padding:1%;\n background-color: #03b4c6;\n color: white;\n border: 0;\n border-radius: 1vh;\n font-weight: bold;\n margin: 1vh;\n}\n.teacherTestimonal{\n    width: 100%;\n    height: 80vh;\n    background:  url('./CourseImages/teacherTestimonal.png');\n    background-size: cover;\n    background-position: center;\n    display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  float: left;\n  margin-top: 2%;\n\n}\n.testimonalBox1,.testimonalBox2{\n  width: 60vh;\n  height: 60vh;\n  background-color: white;\n  border: 0;\n  border-radius: 5vh;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.teacherName{\n  color: #ffb52f;\n  text-align: center;\n  margin: 10%;\n}\n.kidSchool{\n  background:  url('./CourseImages/kidSchool.png');\n  width: 100%;\n  height: 100vh;\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-evenly;\n  float: left;\n  margin-top: 2%; \n}\n.CEOMsg\n{\n  background:  url('./CourseImages/CeoMsgBg.png');\n  background-size: cover;\n  background-position: center;\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 5%;\n}\n\n.footer{\n  width: 100%;\n  height:auto;\n  min-height: 550px;\n  background: url('./CourseImages/footer.png');\n  background-color: rgb(237, 255, 255);\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  /* background-color: #04b2ad; */\n  display: flex;\n  align-items: center; \n  padding: 0 0 6% 0;\n}\n.footerImg{\n  float: left;\n}\n.footerContent{\n  margin-left: 5%;\n  width: 90%;\n  margin-top: 0%;\n}\n.footerText{\n  margin-top: 45%;\n  width: 30%; \n  float: left;\n  font-size: 15px;\n  font-family: sans-serif;\n  color:#ffffff\n}\n.footerLinksSection\n{\n  display: flex;\n  align-items: start;\n  justify-content: center;\n}\n.footerLinks,.footerLinks1,.footerLinks2\n{\n  margin-top: 46vh;\nmargin-left: 20%;\nwidth: 25%;\n  float: left;\n  font-size: smaller;\n  color: white;\n  font-family: sans-serif;\n}\n.footerLinks2\n{\nwidth: 30%;\n}\n.footerLinks1{\n  margin-left: 5%;\n  \n  }\n.footerLinks2{\n    margin-left: 5%;\n    \n}\n\n.avatar-image {\n  border-radius: 50%; /* Makes the image circular */\n  width: 40px; /* Set the width */\n  height: 40px; /* Set the height */\n  margin: 0;\n  padding: 0;\n}\n\n.navLinksArrowHide::after{\n  display: none !important; /* Hide the dropdown arrow icon */\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
